import { clsx } from 'clsx';

import { Typography } from '@monoimin/atoms';

const FallbackComponent = ({
  blok,
  isRichText,
  isPreview,
  component,
}: {
  blok: any;
  isRichText: boolean;
  isPreview: boolean;
  component: any;
}) => {
  const componentName = blok?.component ?? component;

  const targetComponentName = isRichText
    ? 'SbText or in SbComponent'
    : 'SbComponent';
  return isPreview ? (
    <Typography
      as='h3'
      className={clsx('h3 text-orange font-bold', {
        container: !isRichText,
      })}
    >
      {componentName} component doesn&apos;t included into {targetComponentName}
    </Typography>
  ) : null;
};

export function getSbComponent({
  components,
  props,
}: {
  components: { [key: string]: any };
  props: any;
}) {
  //Если блок передается из тела статьи или из других мест верхнего уровня то в блоке присутствует поле component по которому берем нужный компонент из списка
  const TopLevelRenderComponent = components[props?.blok?.component];
  if (TopLevelRenderComponent) {
    return TopLevelRenderComponent;
  }
  //В блоке нету поле component если блок внутри ричтекста и в blokResolvers руками передаем названия компонента как props по которому берем нужный компонент из списка
  const NestedRenderComponent = components[props.component];
  if (NestedRenderComponent) {
    return NestedRenderComponent;
  }
  //И соответственно если компонента не найден в списке возвращаем FallBackComponent с сообщением что этот компонент не включен в списк,
  // сообшение отабражаем только на preview режиме праспотра
  return FallbackComponent;
}
